import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Image from 'react-bootstrap/Image';
import Jumbotron from 'react-bootstrap/Jumbotron';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import { SocialIcon } from 'react-social-icons';
import YoutubeEmbed from "./YoutubeEmbed";
function App() {

  return (
<Container fluid>
{/* This section defines the header*/}
    <Row className = "justify-content-center">
      <Image src='/img/headingcumc.png' />
    </Row>

{/* This section defines the Jumbotron image*/}
  <Jumbotron className = "text-center" id="jumboimg">
    <h5 id = "zoomlabel1">In Person Service Resumes</h5>
  <h1 id = "zoomlabel2">Join us Weekly for Our <br />Live Worship Service</h1>
    <h4 id = "zoomlabel3">English Service meets every Sunday at 10:00 AM PST.  <br />
    For Those Who Cannot Join In Person, <br/> Click The Button Below <br/> to View Our Live Stream!
    <br /> <br /> </h4>
  <br />
  <Button variant = "danger" size ="lg" href="https://rebrand.ly/cumclalive" target="_blank">
    Click to View Youtube Live Stream
  </Button>
  </Jumbotron>



  <div className="paddingforright">
  <div><hr class="solid"></ hr></div>
  </div>


{/* This section defines the Replay image*/}
<Jumbotron className = "text-center" id="jumboimgreplay">
    <h1><b>Service Replay:</b></h1>
  <h3>View A Replay Of Our Latest Worship Service Below</h3>
  <br />

<YoutubeEmbed embedId="videoseries?list=PLFbqRLL3JK_OSIR-4w-5MJ5Jr56Q5UG4Q"/>
  </Jumbotron>

<div className="paddingforright">
<div><hr class="solid"></ hr></div>
<Row className = "text-right">
  <Col className="paddingoforbottom">
  <div className = "text-right"><p1>Chinese United Methodist Church of Los Angeles
    <br />
    825 N Hill St 
    <br />
    Los Angeles, CA 90012</p1>
    </div>
    <div className="paddingoforbottom"></div>
  <SocialIcon url="https://www.facebook.com/groups/164351096937692/" network="facebook" ></SocialIcon>
  <SocialIcon url="https://www.youtube.com/channel/UCXHGCVbEi0K9PcQ6i37J7Dw" network="youtube" ></SocialIcon>
  <SocialIcon url="https://cumcla.org/" network="medium" bgColor="#FE4F29"></SocialIcon>
  </Col>
</Row>

<div className = "text-right">
  <p1>Developed by </p1> 
  <a href={"https://www.lanceaaronsee.com"}>Lance Aaron See</a>
  <p1><br />Release Version 2.1</p1>
  <p1><br />React.JS+Firebase</p1> 
    </div>
    </div>
</Container>


  );
}

export default App;
